import React, { useEffect, useState } from 'react'
import { EmployerLayout } from '../Layout/EmployerLayout'
import classes from './EmployerPage.module.css'
import TextField from '../../../components/TextField/TextField'
import { TextArea } from '../../../components/TextArea/TextArea'
import { Button } from '../../../components/Button/Button'
import { Row } from 'react-bootstrap'
import { LoadingEmployerJob } from '../Job/EmployerJob'
import { authAxios } from '../../../API/apiRequest'
import { FiCamera } from 'react-icons/fi'
import validator from 'validator'
import { useDispatch } from 'react-redux'
import { update } from '../../../State/Slice/userSlice'
interface Props {

}

export const EmployerPage: React.FC<Props> = () => {
    const [loading, setLoading] = useState<boolean>(true)
    const [saving, setSaving] = useState<boolean>(false)
    const [facebook, setFacebook] = useState<string>('')
    const [name, setName] = useState<string>('')
    const [linkedIn, setLinkedIn] = useState<string>('')
    const [website, setWebSite] = useState<string>('')
    const [description, setDiscription] = useState<string>('')
    const [picture, setPicture] = useState<string>('')
    const [newPic, setNewPic] = useState<any>(null)
    const [persent, setPersent] = useState<number>(97)
    const [err, setErr] = useState<null | string>(null)
    const [saved, setSaved] = useState<boolean>(false)
    const dispatch = useDispatch()

    useEffect(()=>{
        async function getData(){
            try{
            let result = await authAxios.get('employer/page')
            setPicture(result.data.picture)
            setDiscription(result.data.description)
            setFacebook(result.data.facebook)
            setWebSite(result.data.website)
            setLinkedIn(result.data.linkedIn)
            setName(result.data.name)
            setLoading(false)
            }catch(e){
                console.log(e)

            }
        }

        getData()


    },[])

    const config = {
        onUploadProgress: (event: any)=>{
            const { loaded, total } = event
            let p = Math.round( (loaded * 100) / total )
            setPersent(p === 100 ? 97 : p)
        },
    }

    const onSave = async()=>{
        try{
            
            if(facebook.trim() !== '' && !validator.isURL(facebook)){
                return setErr('من فضلك تأكد من رابط الفيس بوك')
            }
            if(linkedIn.trim() !== '' && !validator.isURL(linkedIn)){
                return setErr('من فضلك تأكد من رابط لينكد ان')
            }
            if(website.trim() !== '' && !validator.isURL(website)){
               return setErr('من فضلك تأكد من رابط الموقع الإلكتروني')
            }
            setSaving(true)
            const form = new FormData()
            form.append('description', description)
            if(facebook.trim() !== '')
                form.append('fb', facebook)
            if(linkedIn.trim() !== '')
                form.append('li', linkedIn)
            if(website.trim() !== '')
                form.append('wb', website)
            if(newPic !== null)
                form.append('avatar', newPic)
            
            let response = await authAxios.post('employer/page', form, config)
            if(response.status === 200){
                setErr('')
                dispatch(update({picture: response.data.picture}))
                let json = await localStorage.getItem('user')
                if(json){
                    let user = await JSON.parse(json)
                    user.picture = response.data.picture
                    await localStorage.setItem('user', JSON.stringify(user))
                }                
                setSaved(true)
            }
            setSaving(false)
        }catch(e: any){
            if(e.response)
                setErr(e.response.data.errors[0])
            console.log(e)
            setSaving(false)
        }
    }

    if(loading) return <LoadingEmployerJob />
    else
    return (
    <EmployerLayout>
        <Row>
        <div className='col' style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div className={classes.imageContainer} > 
            <img alt='company' src={newPic === null ? picture : URL.createObjectURL(newPic)} className={classes.image}/>
            <div className={classes.selectImage}>
                <label htmlFor='Cimage' className={classes.inpLabel}>
                    <p style={{marginRight: 10}}>اضافة صورة</p>
                    <FiCamera size={20} color='#fff'/>
                </label>
                <input 
                    id='Cimage'
                    type='file'
                    accept="image/png, image/jpg, image/jpeg" 
                    className={classes.imageInput}
                    multiple={false}
                    onChange={({target})=>{
                            if(target.files){
                                if(parseInt(((target.files[0].size/1024)/1024).toString()) > 3){
                                    alert('يجب ان يكون حجم الصورة اقل من 3 Migabyte')
                                    return
                                }else{
                                    setNewPic(target.files[0])
                                }
                            }
                        }
                    }

                />
            </div>
        </div>
        </div>
        </Row>
        <div className={classes.mainInfo}>
        <div className={classes.textContainer}>
                    <TextField 
                    width={240}
                    value={name}
                    disabled
                    bgColor='#4B4B4B'
                    style={{textAlign: 'center', fontWeight: 'bold'}}
                    />
                    <TextArea 
                        style={{marginTop: 5}} 
                        placeholder='وصف لمحل العمل' 
                        bgColor='#4B4B4B'  
                        value={description}
                        handleChange={({target})=>setDiscription(target.value)}
                    />
                </div>
            </div>
           <div className={classes.social}>
               <TextField 
                    iconName='FiFacebook'  
                    style={{textAlign: 'center'}} 
                    bgColor='#4B4B4B' 
                    placeholder='رابط صفحة الفيس بوك'
                    width={200}
                    containerStyle={{margin: 3}}
                    value={facebook}
                    handleChange={({target})=>setFacebook(target.value)}
                />
               <TextField 
                    iconName='FiLinkedin'  
                    style={{textAlign: 'center'}} 
                    bgColor='#4B4B4B'
                    placeholder='رابط لينكد ان'
                    width={200}
                    containerStyle={{margin: 3}}
                    value={linkedIn}
                    handleChange={({target})=>setLinkedIn(target.value)}
                />
               <TextField 
                    iconName='FiGlobe'  
                    style={{textAlign: 'center'}} 
                    bgColor='#4B4B4B'
                    placeholder='رابط الموقع الإلكتروني'
                    width={200}
                    containerStyle={{margin: 3}}
                    value={website}
                    handleChange={({target})=>setWebSite(target.value)}
                />
            </div>
            {err && <p style={{color: 'rgb(230,10,10)', textAlign: 'center'}}>{err}</p>}
            {saved && <p style={{color: 'rgb(10,230,10)', textAlign: 'center'}}>تم الحفظ</p>}
            <div className={classes.btns}>
               <Button 
                    persent={persent} 
                    loading={saving} 
                    style={{alignSelf: 'center', marginBottom: 25}} 
                    color='#5A8D59'
                    onPress={onSave}
                >
                حفظ
                </Button>
            </div>
    </EmployerLayout>
    )
}